// Dependencies
import React, { Component } from 'react';
import { isMobileOnly } from 'react-device-detect';

// Primereact imports
import { Button } from 'primereact/button';
import { Chip } from 'primereact/chip';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Tooltip } from 'primereact/tooltip';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';

// Styling
import './personal-data.scss';

// Multi lang
import { getLanguage, withTranslation } from 'react-multi-lang';

// Utils
import { DOC_TYPE_COMP_NIF, DOC_TYPE_CRIMINAL, DOC_TYPE_IDENTIFICATION, DOC_TYPE_PHOTO, DOC_TYPE_RESIDENCE_COMP, DOC_TYPE_SIGNATURE, PERSONAL, YES_OPTION } from '../../../common/constants';
import { COUNCIL_LIST, DCF_LIST, DISTRICT_LIST } from '../../../common/lists/dcf';
import { getContactTypeList, getGenderList, getTranslatedContactTypeOption, getTranslatedGenderOption, STREET_TYPE_LIST } from '../../../common/lists/personal';
import { NON_EU_LIST, PORTUGAL, WORLD_LIST } from '../../../common/lists/countries';
import { formatPersonalDataFormValues } from '../../../common/formatters/personal';
import { convertBase64ToArrayBuffer, downloadFile } from '../../../common/utils/download-utils';
import { getRegistrationDoc } from '../../../common/utils/registration-utils';
import { formatYesNoDropdownLists, getYesNoDropdownList } from '../../../common/utils/form-data-utils';
import { validateNIF } from '../../../common/utils/validation-utils';
import { getPrettyDate } from '../../../common/utils/date-utils';

// Redux
import { connect } from 'react-redux';
import DocumentService from '../../../redux/services/document';
import { getAssociateData, setEditMode } from '../../../redux/actions/profile';
import ProfileService from '../../../redux/services/profile';
import { formatAssociateDataToService } from '../../../common/formatters/associate';
import PaymentService from '../../../redux/services/payment';

class PersonalDataComponent extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();
        this.state = {
            name: "",
            professionalName: "",
            prettyBirthDate: "",
            birthDate: null,
            portugueseCitizen: null,
            portugueseAddress: null,
            identificationNumber: "",
            streetType: null,
            streetTypePlaceholder: "",
            addressLine: "",
            addressLine2: "",
            doorNumber: "",
            doorFloor: "",
            auxPlace: "",
            cP4: "",
            cP3: "",
            city: "",
            region: "",
            county: null,
            district: null,
            country: null,
            email: "",
            telephonePrefix: "",
            telephone: "",
            mobilePhonePrefix: "",
            mobilePhone: "",
            preferredContact: null,
            nationality: null,
            birthPlace: "",
            father: "",
            mother: "",
            gender: "",
            nifCountry: null,
            nif: "",
            niss: "",
            iban: "",
            readOnlyMode: true,
            criminalDocAttachment: null,
            criminalDocAttachmentName: "",
            photoAttachment: null,
            photoAttachmentName: "",
            criminalDoc: null,
            photoDoc: null,
            identificationDoc: null,
            signatureDoc: null,
            residenceDoc: null,
            compNifDoc: null,
            canChangeNifInformation: false,
            canChangeCCInformation: false,
            // Mandatory fields validation
            validAddressLine: true,
            validDoorNumber: true,
            validCp: true,
            validCpFormat: true,
            validCity: true,
            validEmail: true,
            validEmailFormat: true,
            validMobilePhone: true,
            validMobilePhoneFormat: true,
            validTelephoneFormat: true,
            validUploadFile: true,
            validIban: true,
            validNiss: true,
            validNif: true,
            validNifFormat: true,
            validCC: true,
            validCCFormat: true,
            validRegion: true,
            validCountry: true
        };
    }

    componentDidMount() {  
        this.setState({
            name: this.props.associate.personalData.name,
            professionalName: this.props.associate.personalData.professionalName,
            birthDate: this.props.associate.personalData.birthDate,
            prettyBirthDate: this.props.associate.personalData.prettyBirthDate,
            portugueseCitizen: this.props.associate.personalData.portugueseCitizen,
            portugueseAddress: this.props.associate.personalData.portugueseAddress,
            identificationNumber: this.props.associate.personalData.identificationNumber,
            streetType: this.props.associate.personalData.streetType,
            streetTypePlaceholder: this.props.associate.personalData.streetTypePlaceholder,
            addressLine: this.props.associate.personalData.addressLine,
            addressLine2: this.props.associate.personalData.addressLine2,
            doorNumber: this.props.associate.personalData.doorNumber,
            doorFloor: this.props.associate.personalData.doorFloor,
            auxPlace: this.props.associate.personalData.auxPlace,
            cP4: this.props.associate.personalData.cP4,
            cP3: this.props.associate.personalData.cP3,
            city: this.props.associate.personalData.city,
            region: this.props.associate.personalData.region,
            county: this.props.associate.personalData.county,
            district: this.props.associate.personalData.district,
            country: typeof this.props.associate.personalData.country !== 'object' && this.props.associate.personalData.country !== null
                ? { name: this.props.associate.personalData.country, code: this.props.associate.personalData.country }
                : this.props.associate.personalData.country,
            email: this.props.associate.personalData.email,
            telephonePrefix: this.props.associate.personalData.telephonePrefix, 
            telephone: this.props.associate.personalData.telephone,
            mobilePhonePrefix: this.props.associate.personalData.mobilePhonePrefix,
            mobilePhone: this.props.associate.personalData.mobilePhone,
            preferredContact: this.props.associate.personalData.preferredContact,
            nationality: this.props.associate.personalData.nationality,
            birthPlace: this.props.associate.personalData.birthPlace,
            father: this.props.associate.personalData.father,
            mother: this.props.associate.personalData.mother,
            gender: this.props.associate.personalData.gender,
            nifCountry: this.props.associate.personalData.nifCountry,
            nif: this.props.associate.personalData.nif,
            niss: this.props.associate.personalData.niss,
            iban: this.props.associate.personalData.iban,
            criminalDoc: getRegistrationDoc(this.props.registrationDocs, DOC_TYPE_CRIMINAL),
            photoDoc: getRegistrationDoc(this.props.registrationDocs, DOC_TYPE_PHOTO),
            identificationDoc: getRegistrationDoc(this.props.registrationDocs, DOC_TYPE_IDENTIFICATION),
            signatureDoc: getRegistrationDoc(this.props.registrationDocs, DOC_TYPE_SIGNATURE),
            residenceDoc: getRegistrationDoc(this.props.registrationDocs, DOC_TYPE_RESIDENCE_COMP),
            compNifDoc: getRegistrationDoc(this.props.registrationDocs, DOC_TYPE_COMP_NIF),
            canChangeNifInformation: this.props.associate.personalData.nifCountry.code !== PORTUGAL.code,
            canChangeCCInformation: this.props.associate.personalData.portugueseCitizen.code !== YES_OPTION.code
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.language !== prevProps.language) {
            this.reloadFormData();
        }
    }

    activateEditMode() {
        this.setState({
            readOnlyMode: false
        });

        this.props.setEditMode(true);
    }

    cancelEditMode() {
        this.reloadFormData();
        this.setState({
            readOnlyMode: true
        });
        
        this.props.setEditMode(false);
    }

    reloadFormData() {
        let associate = this.formatPersonalDataFormValues(this.props.associate, this.props.language);
            
        this.setState({
            name: this.props.associate.personalData.name,
            professionalName: this.props.associate.personalData.professionalName,
            birthDate: associate.personalData.birthDate,
            prettyBirthDate: associate.personalData.prettyBirthDate,
            portugueseCitizen: associate.personalData.portugueseCitizen,
            portugueseAddress: associate.personalData.portugueseAddress,
            identificationNumber: this.props.associate.personalData.identificationNumber,
            streetType: associate.personalData.streetType,
            streetTypePlaceholder: this.props.associate.personalData.streetTypePlaceholder,
            addressLine: this.props.associate.personalData.addressLine,
            addressLine2: this.props.associate.personalData.addressLine2,
            doorNumber: this.props.associate.personalData.doorNumber,
            doorFloor: this.props.associate.personalData.doorFloor,
            auxPlace: this.props.associate.personalData.auxPlace,
            cP4: this.props.associate.personalData.cP4,
            cP3: this.props.associate.personalData.cP3,
            city: this.props.associate.personalData.city,
            region: this.props.associate.personalData.region,
            county: associate.personalData.county,
            district: associate.personalData.district,
            country: associate.personalData.country,
            email: this.props.associate.personalData.email,
            telephonePrefix: this.props.associate.personalData.telephonePrefix, 
            telephone: this.props.associate.personalData.telephone,
            mobilePhonePrefix: this.props.associate.personalData.mobilePhonePrefix,
            mobilePhone: this.props.associate.personalData.mobilePhone,
            preferredContact: associate.personalData.preferredContact,
            nationality: associate.personalData.nationality,
            birthPlace: this.props.associate.personalData.birthPlace,
            father: this.props.associate.personalData.father,
            mother: this.props.associate.personalData.mother,
            gender: associate.personalData.gender,
            nifCountry: associate.personalData.nifCountry,
            nif: this.props.associate.personalData.nif,
            niss: this.props.associate.personalData.niss,
            iban: this.props.associate.personalData.iban
        });
    }

    saveChanges() {
        if(this.validateForm()) {

            if(this.state.iban !== null && this.state.iban !== "") {
                PaymentService.validateIBAN(this.state.iban.replace(' ','')).then((response) => { 
                    this.setState({
                        validIban: response
                    });

                    if(response === true) {
                        this.updateProfileData();
                    }
        
                })
                .catch(error => {
                    this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
                });
            }
            else {
                this.setState({
                    validIban: true
                });

                this.updateProfileData();
            }
        }
    }

    updateProfileData() {

        let associate = this.props.associate;
        associate.personalData = {
            name: this.state.name,
            professionalName: this.state.professionalName,
            birthDate: this.state.birthDate,
            portugueseCitizen: this.state.portugueseCitizen,
            portugueseAddress: this.state.portugueseAddress,
            identificationNumber: this.state.identificationNumber,
            streetType: this.state.portugueseAddress.code === YES_OPTION.code ? this.state.streetType : null,
            streetTypePlaceholder: this.state.portugueseAddress.code === YES_OPTION.code ? this.state.streetTypePlaceholder : null,
            addressLine: this.state.addressLine,
            addressLine2: this.state.addressLine2,
            doorNumber: this.state.portugueseAddress.code === YES_OPTION.code ? this.state.doorNumber : null,
            doorFloor: this.state.portugueseAddress.code === YES_OPTION.code ? this.state.doorFloor : null,
            auxPlace: this.state.portugueseAddress.code === YES_OPTION.code ? this.state.auxPlace : null,
            cP4: this.state.cP4,
            cP3: this.state.cP3,
            city: this.state.city,
            county: this.state.county,
            district: this.state.district,
            region: this.state.region,
            country: (this.state.portugueseAddress !== null && this.state.portugueseAddress.code === YES_OPTION.code) ? "Portugal" : this.state.country,
            email: this.state.email,
            telephonePrefix: this.state.telephonePrefix, 
            telephone: this.state.telephone,
            mobilePhonePrefix: this.state.mobilePhonePrefix,
            mobilePhone: this.state.mobilePhone,
            preferredContact: this.state.preferredContact,
            nationality: this.state.nationality,
            birthPlace: this.state.birthPlace,
            father: this.state.father,
            mother: this.state.mother,
            gender: this.state.gender,
            nifCountry: this.state.nifCountry,
            nif: this.state.nif,
            niss: this.state.niss,
            iban: this.state.iban
        };

        ProfileService.updateAssociateData(formatAssociateDataToService(associate), this.props.t('general.update-record'), PERSONAL)
        .then((response) => {
            
            if(this.state.criminalDocAttachment !== null) {
                ProfileService.uploadAssociateDocument(this.state.criminalDocAttachment, this.props.registrationRef.toString(), DOC_TYPE_CRIMINAL)
                .then((response) => {
                    this.props.getAssociateData(this.props.registrationRef);

                    setTimeout(() => {
                        this.setState({
                            criminalDoc: getRegistrationDoc(this.props.registrationDocs, DOC_TYPE_CRIMINAL),
                            canChangeNifInformation: this.props.associate.personalData.nifCountry.code !== PORTUGAL.code,
                            canChangeCCInformation: this.props.associate.personalData.portugueseCitizen.code !== YES_OPTION.code
                        });
                    }, 1500);
                })
                .catch(error => {
                    this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
                });
            }

            if(this.state.photoAttachment !== null) {
                ProfileService.uploadAssociateDocument(this.state.photoAttachment, this.props.registrationRef.toString(), DOC_TYPE_PHOTO)
                .then((response) => {
                    this.props.getAssociateData(this.props.registrationRef);

                    setTimeout(() => {
                        this.setState({
                            photoDoc: getRegistrationDoc(this.props.registrationDocs, DOC_TYPE_PHOTO),
                            canChangeNifInformation: this.props.associate.personalData.nifCountry.code !== PORTUGAL.code,
                            canChangeCCInformation: this.props.associate.personalData.portugueseCitizen.code !== YES_OPTION.code
                        });
                    }, 1500);
                })
                .catch(error => {
                    this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
                });
            }

            if(this.state.criminalDocAttachment === null && this.state.photoAttachment === null) {
                this.props.getAssociateData(this.props.registrationRef);

                setTimeout(() => {
                    this.setState({
                        canChangeNifInformation: this.props.associate.personalData.nifCountry.code !== PORTUGAL.code,
                        canChangeCCInformation: this.props.associate.personalData.portugueseCitizen.code !== YES_OPTION.code
                    });
                }, 1500);
            }

            this.setState({
                readOnlyMode: true
            });

            this.props.setEditMode(false);
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
        });
    }

    validateForm() {
        let validationResult = true;
        
        // Postal code custom validation
        let validCp = (this.state.cP4 !== "" && this.state.cP3 !== "");
        let validCpFormat = true;

        if(validCp) {
            validCpFormat = (this.state.cP4.match(/^[0-9]+$/) !== null) && (this.state.cP3.match(/^[0-9]+$/) !== null);
        }

        // Telephone numbers custom validation
        let validMobilePhone = (this.state.mobilePhone !== "");
        let validMobilePhoneFormat = true;

        if(validMobilePhone) {
            validMobilePhoneFormat = (this.state.mobilePhone.match(/^[0-9]+$/) !== null);
        }

        let validTelephoneFormat = true;
        if(this.state.telephone !== "") {
            validTelephoneFormat = (this.state.telephone.match(/^[0-9]+$/) !== null);
        }

        // Email address custom validation
        let validEmail = (this.state.email !== "");
        let validEmailFormat = true;

        if(validEmail) {
            validEmailFormat = (this.state.email.match(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/) !== null);
        }

        // CC validation
        let validCC = (this.state.identificationNumber !== "");
        let validCCFormat = true;

        if(this.state.portugueseCitizen.code === YES_OPTION.code) {
            validCCFormat = Number.isInteger(Number(this.state.identificationNumber)) && (this.state.identificationNumber.length === 7 || this.state.identificationNumber.length === 8 );
        }

        // NIF validation
        let validNif = (this.state.nif !== "");
        let validNifFormat = true;

        if(this.state.nifCountry.code === PORTUGAL.code) {
            validNifFormat = validateNIF(this.state.nif);
        }

        // NISS validation
        let validNiss = true;

        if(this.state.niss !== null && this.state.niss !== "") {
            validNiss = Number.isInteger(Number(this.state.niss));
        }

        // Non portuguese address validation
        let validRegion = true;
        let validCountry = true;

        if(this.state.portugueseAddress !== null && this.state.portugueseAddress.code !== YES_OPTION.code) {
            validRegion = (this.state.region !== null && this.state.region !== "");
            validCountry = (this.state.country !== null && !!this.state.country.code);
        }

        this.setState({
            validAddressLine: this.state.addressLine !== "",
            validDoorNumber: this.state.doorNumber !== "",
            validCp: validCp,
            validCpFormat: validCpFormat,
            validCity: this.state.city !== "",
            validEmail: this.state.email !== "",
            validMobilePhone: validMobilePhone,
            validMobilePhoneFormat: validMobilePhoneFormat,
            validTelephoneFormat: validTelephoneFormat,
            validEmailFormat: validEmailFormat,
            validNiss: validNiss,
            validNif: validNif,
            validNifFormat: validNifFormat,
            validCC: validCC,
            validCCFormat: validCCFormat,
            validRegion: validRegion,
            validCountry: validCountry
        });

        validationResult = (this.state.addressLine !== "" &&
                            (this.state.portugueseAddress === null || this.state.portugueseAddress.code !== YES_OPTION.code || this.state.doorNumber !== "") &&
                            validCp &&
                            validCpFormat &&
                            this.state.city !== "" &&
                            this.state.email !== "" &&
                            validMobilePhone &&
                            validMobilePhoneFormat &&
                            validTelephoneFormat &&
                            validEmailFormat &&
                            validNiss &&
                            validNif &&
                            validCC &&
                            validCCFormat &&
                            validRegion &&
                            validCountry);

        return validationResult;
    }

    updateFormComponent(column, value) {
        this.setState({
            [column]: value
        });

        if(column === "county") {
            for (let i = 0; i < DCF_LIST.length; i++) {
                if(DCF_LIST[i].council === value.code) {
                    this.setState({
                        district: { code: DCF_LIST[i].district, name: DCF_LIST[i].district }
                    });
                }
            }
        }
        else if(column === "streetType") {
            this.setState({
                streetTypePlaceholder: value.name
            });
        }
        else if(column === "portugueseAddress") {
            this.setState({
                addressLine2: "",
                country: null
            });
        }
    }

    downloadDocument(documentRef) {
        DocumentService.downloadDocument(documentRef)
          .then((response) => {
                var blob = new Blob([convertBase64ToArrayBuffer(response.fileContent)], { type: response.contentType });
                downloadFile(URL.createObjectURL(blob), response.filename);
          })
          .catch(error => {
              this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
          });
    }

    uploadDocumentHandler(document, documentType) {
        let self = this;
        var reader = new FileReader();
        reader.readAsBinaryString(document[0]);

        reader.onload = function() {
            if(documentType === "criminal_record") {
                self.setState({
                    criminalDocAttachment: btoa(reader.result),
                    criminalDocAttachmentName: document[0].name,
                    validUploadFile: true
                });
            }
            else {
                self.setState({
                    photoAttachment: btoa(reader.result),
                    photoAttachmentName: document[0].name,
                    validUploadFile: true
                });
            }
        };
    }

    formatPersonalDataFormValues(sourceAssociate, language="pt") { 

        let associate = {
            personalData: {}
        };

        associate.personalData.prettyBirthDate = sourceAssociate.personalData.birthDate !== null ? getPrettyDate(sourceAssociate.personalData.birthDate) : null;
        
        if(typeof sourceAssociate.personalData.portugueseCitizen !== 'object' && sourceAssociate.personalData.portugueseCitizen !== null) {
            associate.personalData.portugueseCitizen = formatYesNoDropdownLists(sourceAssociate.personalData.portugueseCitizen, language);
        }
        else if (typeof sourceAssociate.personalData.portugueseCitizen  === 'object' && sourceAssociate.personalData.portugueseCitizen !== null) {
            associate.personalData.portugueseCitizen = formatYesNoDropdownLists(sourceAssociate.personalData.portugueseCitizen.code === YES_OPTION.code, language);
        }
    
        if(typeof sourceAssociate.personalData.district !== 'object' && sourceAssociate.personalData.district !== null) {
            associate.personalData.portugueseAddress = formatYesNoDropdownLists(sourceAssociate.personalData.district !== null, language);
        }
        else if (typeof sourceAssociate.personalData.district  === 'object' && sourceAssociate.personalData.district !== null) {
            associate.personalData.portugueseAddress = formatYesNoDropdownLists(sourceAssociate.personalData.district !== null, language);
        }
    
        if(typeof sourceAssociate.personalData.county !== 'object' && sourceAssociate.personalData.county !== null) {
            associate.personalData.county = { name: sourceAssociate.personalData.county, code: sourceAssociate.personalData.county };
        }
        else {
            associate.personalData.county = sourceAssociate.personalData.county;
        }
    
        if(typeof sourceAssociate.personalData.district !== 'object' && sourceAssociate.personalData.district !== null) {
            associate.personalData.district = { name: sourceAssociate.personalData.district, code: sourceAssociate.personalData.district };
        }
        else {
            associate.personalData.district = sourceAssociate.personalData.district;
        }
    
        if(typeof sourceAssociate.personalData.country !== 'object' && sourceAssociate.personalData.country !== null) {
            associate.personalData.country = { name: sourceAssociate.personalData.country, code: sourceAssociate.personalData.country };
        }
        else {
            associate.personalData.country = sourceAssociate.personalData.country;
        }

        if(typeof sourceAssociate.personalData.preferredContact !== 'object' && sourceAssociate.personalData.preferredContact !== null) {
            associate.personalData.preferredContact = { name: sourceAssociate.personalData.preferredContact, code: sourceAssociate.personalData.preferredContact };
        }
        else if (typeof sourceAssociate.personalData.preferredContact === 'object' && sourceAssociate.personalData.preferredContact !== null) {
            associate.personalData.preferredContact = getTranslatedContactTypeOption(sourceAssociate.personalData.preferredContact.code, language);
        }
    
        if(typeof sourceAssociate.personalData.nationality !== 'object' && sourceAssociate.personalData.nationality !== null) {
            associate.personalData.nationality = { name: sourceAssociate.personalData.nationality, code: sourceAssociate.personalData.nationality };
        }
        else {
            associate.personalData.nationality = sourceAssociate.personalData.nationality;
        }

        if(typeof sourceAssociate.personalData.gender !== 'object' && sourceAssociate.personalData.gender !== null) {
            associate.personalData.gender = { name: sourceAssociate.personalData.gender, code: sourceAssociate.personalData.gender };
        }
        else if (typeof sourceAssociate.personalData.gender === 'object' && sourceAssociate.personalData.gender !== null) {
            associate.personalData.gender = getTranslatedGenderOption(sourceAssociate.personalData.gender.code, language);
        }
    
        if(typeof sourceAssociate.personalData.nifCountry !== 'object' && sourceAssociate.personalData.nifCountry !== null) {
            associate.personalData.nifCountry = { name: sourceAssociate.personalData.nifCountry, code: sourceAssociate.personalData.nifCountry };
        }
        else {
            associate.personalData.nifCountry = sourceAssociate.personalData.nifCountry;
        }
    
        if(typeof sourceAssociate.personalData.streetType !== 'object' && sourceAssociate.personalData.streetType !== null) {
            associate.personalData.streetType = { name: sourceAssociate.personalData.streetTypePlaceholder, code: sourceAssociate.personalData.streetType };
        }
        else {
            associate.personalData.streetType = sourceAssociate.personalData.streetType;
        }
    
        return associate;
    }

    render() {
        return (
            this.props.associate !== null && this.props.associate.personalData !== null ? 
                <div className='grid mgb-80'>
                    <Tooltip target=".personal-data-help-icon" />
                    <div className='col-12'>
                        <div className="card p-fluid mgt-20">
                            <div className='grid'>
                                <div className='col-12 t-align-right'>
                                {
                                    this.state.readOnlyMode === true ? 
                                        <Button icon="pi pi-pencil" disabled={!this.props.registrationApproved} className="p-button-rounded mr-2 mb-2" onClick={() => this.activateEditMode()} />
                                        :   
                                        <>
                                            <Button icon="pi pi-check" className="p-button-rounded p-button-success mr-2 mb-2" onClick={() => this.saveChanges()} />
                                            <Button icon="pi pi-ban" className="p-button-rounded p-button-danger mr-2 mb-2" onClick={() => this.cancelEditMode()} />
                                        </>
                                }
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="name">{this.props.t("profile.areas.personal.name")} <span className="invalid-message">*</span></label>
                                    <InputText value={this.state.name} disabled={true/*this.state.readOnlyMode*/} id="name" type="text" onChange={(evt) => this.updateFormComponent("name", evt.target.value)} />
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="professionalName">{this.props.t("profile.areas.personal.professional-name")} <span className="invalid-message">*</span></label>
                                    <InputText value={this.state.professionalName} disabled={true} id="professionalName" type="text" />
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="prettyBirthDate">{this.props.t("profile.areas.personal.birth-date")} <span className="invalid-message">*</span></label>
                                    <InputText value={this.state.prettyBirthDate} disabled={true} id="prettyBirthDate" type="text" />
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="portuguese">{this.props.t("profile.areas.personal.portuguese-citizen")} <span className="invalid-message">*</span></label>
                                    <Dropdown value={this.state.portugueseCitizen} disabled={!this.state.portugueseCitizen || this.state.readOnlyMode} id="portuguese" options={getYesNoDropdownList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("portugueseCitizen", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="portugueseAddress">{this.props.t("profile.areas.personal.portuguese-address")}</label>
                                    <Dropdown value={this.state.portugueseAddress} disabled={this.state.readOnlyMode} id="portugueseAddress" options={getYesNoDropdownList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("portugueseAddress", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                    <label htmlFor="identificationNumber">{this.props.t("profile.areas.personal.identification-number")} <span className="invalid-message">*</span></label>
                                    <InputText value={this.state.identificationNumber} disabled={true/*this.state.readOnlyMode || !this.state.canChangeCCInformation*/} id="identificationNumber" type="text" onChange={(evt) => this.updateFormComponent("identificationNumber", evt.target.value)} />
                                    { this.state.validCC ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                    { this.state.validCCFormat ? null : <p><small className="p-error">{this.props.t("profile.areas.personal.invalid-cc")}</small></p>  }
                                </div>
                                {
                                    this.state.portugueseAddress !== null && this.state.portugueseAddress.code === YES_OPTION.code ?
                                        <>
                                            <div className='col-12 md:col-12 lg:col-2 t-align-left'>
                                                <label htmlFor="streetType">{this.props.t("profile.areas.personal.street-type")}</label>
                                                <Dropdown showClear={true} value={this.state.streetType} disabled={this.state.readOnlyMode} id="streetType" options={STREET_TYPE_LIST} optionLabel="name" onChange={(evt) => this.updateFormComponent("streetType", evt.value)}></Dropdown>
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="address1">{this.props.t("profile.areas.personal.address-line")} <span className="invalid-message">*</span></label>
                                                <InputText maxLength="100" value={this.state.addressLine} disabled={this.state.readOnlyMode} id="address1" type="text" onChange={(evt) => this.updateFormComponent("addressLine", evt.target.value)} />
                                                { this.state.validAddressLine ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                        </>
                                        : 
                                        <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                            <label htmlFor="address1">{this.props.t("profile.areas.personal.address-line")} <span className="invalid-message">*</span></label>
                                            <InputText maxLength="100" value={this.state.addressLine} disabled={this.state.readOnlyMode} id="address1" type="text" onChange={(evt) => this.updateFormComponent("addressLine", evt.target.value)} />
                                            { this.state.validAddressLine ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                        </div>                                    
                                } 
                                {
                                    this.state.portugueseAddress !== null && this.state.portugueseAddress.code === YES_OPTION.code ?
                                    <>
                                        <div className='col-12 md:col-12 lg:col-1 t-align-left'>
                                            <label htmlFor="doorNumber">{this.props.t("profile.areas.personal.door-number")} <span className="invalid-message">*</span></label>
                                            <InputText value={this.state.doorNumber} disabled={this.state.readOnlyMode} id="doorNumber" type="text" onChange={(evt) => this.updateFormComponent("doorNumber", evt.target.value)} />
                                            { this.state.validDoorNumber ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                        </div>
                                        <div className='col-12 md:col-12 lg:col-1 t-align-left'>
                                            <label htmlFor="doorFloor">{this.props.t("profile.areas.personal.door-floor")}</label>
                                            <InputText value={this.state.doorFloor} disabled={this.state.readOnlyMode} id="doorFloor" type="text" onChange={(evt) => this.updateFormComponent("doorFloor", evt.target.value)} />
                                        </div>
                                        <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                            <label htmlFor="auxPlace">{this.props.t("profile.areas.personal.aux-place")}</label>
                                            <InputText value={this.state.auxPlace} disabled={this.state.readOnlyMode} id="auxPlace" type="text" onChange={(evt) => this.updateFormComponent("auxPlace", evt.target.value)} />
                                        </div>
                                    </>
                                    : 
                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                        <label htmlFor="address2">{this.props.t("profile.areas.personal.address-line-2")}</label>
                                        <InputText value={this.state.addressLine2} disabled={this.state.readOnlyMode} id="address2" type="text" onChange={(evt) => this.updateFormComponent("addressLine2", evt.target.value)} />
                                    </div>
                                } 
                                {
                                    this.state.portugueseAddress !== null && this.state.portugueseAddress.code === YES_OPTION.code ?
                                        <>
                                            <div className='col-6 md:col-6 lg:col-2 t-align-left'>
                                                <label htmlFor="cp4">{this.props.t("profile.areas.personal.postal-code")} <span className="invalid-message">*</span></label>
                                                <InputText value={this.state.cP4} disabled={this.state.readOnlyMode} id="cp4" type="text" pattern="\d*" maxLength="4" onChange={(evt) => this.updateFormComponent("cP4", evt.target.value)}  />
                                                { this.state.validCp ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                { this.state.validCpFormat ? null : <small className="p-error">{this.props.t("general.wrong-cp-format")}</small>  }
                                            </div>
                                            <div className='col-6 md:col-6 lg:col-1 t-align-left mgt-16'>
                                                <InputText value={this.state.cP3} disabled={this.state.readOnlyMode} id="cp3" type="text" pattern="\d*" maxLength="3" onChange={(evt) => this.updateFormComponent("cP3", evt.target.value)}  />
                                            </div>
                                        </>
                                        :
                                        <div className='col-6 md:col-6 lg:col-3 t-align-left'>
                                            <label htmlFor="cp4">{this.props.t("profile.areas.personal.postal-code")} <span className="invalid-message">*</span></label>
                                            <InputText value={this.state.cP4} disabled={this.state.readOnlyMode} id="cp4" type="text" pattern="\d*" maxLength="4" onChange={(evt) => this.updateFormComponent("cP4", evt.target.value)}  />
                                            { this.state.validCp ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            { this.state.validCpFormat ? null : <small className="p-error">{this.props.t("general.wrong-cp-format")}</small>  }
                                        </div> 
                                }
                                <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                                    <label htmlFor="city">{this.props.t("profile.areas.personal.city")} <span className="invalid-message">*</span></label>
                                    <InputText value={this.state.city} disabled={this.state.readOnlyMode} id="city" type="text" onChange={(evt) => this.updateFormComponent("city", evt.target.value)}  />
                                    { this.state.validCity ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                </div>
                                {
                                    this.state.portugueseAddress !== null && this.state.portugueseAddress.code === YES_OPTION.code ?
                                    <>
                                        <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                                            <label htmlFor="county">{this.props.t("profile.areas.personal.council")} 
                                                <span className='mgr-5 invalid-message'>*</span>
                                                <i className="personal-data-help-icon pi pi-question-circle p-text-secondary" data-pr-tooltip={this.props.t("profile.areas.personal.help-messages.address")} data-pr-position="right" data-pr-at="right+5 center" data-pr-my="left center-2" style={{ color:"#0073aa", fontSize:"16px", fontWeight:"bold", cursor: 'pointer' }}></i>
                                            </label>
                                            <Dropdown id="county" value={this.state.county} disabled={this.state.readOnlyMode} options={COUNCIL_LIST} optionLabel="name" onChange={(evt) => this.updateFormComponent("county", evt.value)}></Dropdown>
                                        </div>
                                        <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                                            <label htmlFor="district">{this.props.t("profile.areas.personal.district")} 
                                                <span className='mgr-5 invalid-message'>*</span>
                                                <i className="personal-data-help-icon pi pi-question-circle p-text-secondary" data-pr-tooltip={this.props.t("profile.areas.personal.help-messages.address")} data-pr-position="right" data-pr-at="right+5 center" data-pr-my="left center-2" style={{ color:"#0073aa", fontSize:"16px", fontWeight:"bold", cursor: 'pointer' }}></i>
                                            </label>
                                            <Dropdown id="district" value={this.state.district} disabled={true} options={DISTRICT_LIST} optionLabel="name"></Dropdown>
                                        </div>
                                    </> 
                                    : 
                                    <>
                                        <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                                            <label htmlFor="region">{this.props.t("profile.areas.personal.region")} <span className="invalid-message">*</span></label>
                                            <InputText value={this.state.region} disabled={this.state.readOnlyMode} id="region" type="text" onChange={(evt) => this.updateFormComponent("region", evt.target.value)}  />
                                            { this.state.validRegion ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                        </div>
                                        <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                                            <label htmlFor="country">{this.props.t("profile.areas.personal.country")} 
                                                <span className='mgr-5 invalid-message'>*</span>
                                            </label>
                                            <Dropdown id="country" value={this.state.country} disabled={this.state.readOnlyMode} options={NON_EU_LIST} optionLabel="name" onChange={(evt) => this.updateFormComponent("country", evt.value)}></Dropdown>
                                            { this.state.validCountry ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                        </div>
                                    </> 
                                }
                                <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                                    <label htmlFor="email">{this.props.t("profile.areas.personal.email")} <span className="invalid-message">*</span></label>
                                    <InputText id="email" value={this.state.email} disabled={this.state.readOnlyMode} type="text" onChange={(evt) => this.updateFormComponent("email", evt.target.value)} />
                                    { this.state.validEmail ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                    { this.state.validEmailFormat ? null : <small className="p-error">{this.props.t("general.wrong-email-format")}</small>  }
                                </div>
                                <div className='col-4 md:col-4 lg:col-1 t-align-left'>
                                    <label htmlFor="telephonePrefix">{this.props.t("profile.areas.personal.telephone")}</label>
                                    <InputText id="telephonePrefix" value={this.state.telephonePrefix} disabled={this.state.readOnlyMode} type="text" placeholder='+' pattern="\d*" maxLength="3" onChange={(evt) => this.updateFormComponent("telephonePrefix", evt.target.value)}  />
                                </div>
                                <div className='col-8 md:col-8 lg:col-2 t-align-left mgt-16'>
                                    <InputText id="telephone" value={this.state.telephone} disabled={this.state.readOnlyMode} type="text" pattern="\d*" maxLength="15" onChange={(evt) => this.updateFormComponent("telephone", evt.target.value)} />
                                    { this.state.validTelephoneFormat ? null : <small className="p-error">{this.props.t("general.wrong-phone-format")}</small>  }
                                </div>
                                <div className='col-4 md:col-4 lg:col-1 t-align-left'>
                                    <label htmlFor="mobilePhonePrefix">{this.props.t("profile.areas.personal.mobile-phone")} <span className="invalid-message">*</span></label>
                                    <InputText id="mobilePhonePrefix" value={this.state.mobilePhonePrefix} disabled={this.state.readOnlyMode} type="text" placeholder='+' pattern="\d*" maxLength="3" onChange={(evt) => this.updateFormComponent("mobilePhonePrefix", evt.target.value)} />
                                </div>
                                <div className='col-8 md:col-8 lg:col-2 t-align-left mgt-16'>
                                    <InputText id="mobilePhone" disabled={this.state.readOnlyMode} value={this.state.mobilePhone} type="text" pattern="\d*" maxLength="15" onChange={(evt) => this.updateFormComponent("mobilePhone", evt.target.value)} />
                                    { this.state.validMobilePhone ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                    { this.state.validMobilePhoneFormat ? null : <small className="p-error">{this.props.t("general.wrong-phone-format")}</small>  }
                                </div>
                                <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                                    <label htmlFor="contact">{this.props.t("profile.areas.personal.contact")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="contact" value={this.state.preferredContact} disabled={this.state.readOnlyMode} options={getContactTypeList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("preferredContact", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                    <label htmlFor="nationality">{this.props.t("profile.areas.personal.nationality")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="nationality" value={this.state.nationality} disabled={true} options={WORLD_LIST} optionLabel="name" ></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                    <label htmlFor="birthPlace">{this.props.t("profile.areas.personal.birth-place")} <span className="invalid-message">*</span></label>
                                    <InputText id="birthPlace" value={this.state.birthPlace} disabled={true} type="text" />
                                </div>
                                <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                    <label htmlFor="father">{this.props.t("profile.areas.personal.father")} <span className="invalid-message">*</span></label>
                                    <InputText id="father" value={this.state.father} disabled={true} type="text" />
                                </div>
                                <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                    <label htmlFor="mother">{this.props.t("profile.areas.personal.mother")} <span className="invalid-message">*</span></label>
                                    <InputText id="mother" value={this.state.mother} disabled={true} type="text" />
                                </div>
                                <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                                    <label htmlFor="gender">{this.props.t("profile.areas.personal.gender")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="gender" value={this.state.gender} disabled={true} options={getGenderList(getLanguage())} optionLabel="name"></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                                    <label htmlFor="nifCountry">{this.props.t("profile.areas.personal.nif-country")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="nifCountry" value={this.state.nifCountry} disabled={true/*this.state.readOnlyMode || !this.state.canChangeNifInformation*/} options={WORLD_LIST} optionLabel="name" onChange={(evt) => this.updateFormComponent("nifCountry", evt.value)}></Dropdown>
                                </div>
                                <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                                    <label htmlFor="nif">{this.props.t("profile.areas.personal.nif")} 
                                        <span className='mgr-5 invalid-message'>*</span>
                                        <i className="personal-data-help-icon pi pi-question-circle p-text-secondary" data-pr-tooltip={this.props.t("profile.areas.personal.help-messages.nif")} data-pr-position="right" data-pr-at="right+5 center" data-pr-my="left center-2" style={{ color:"#0073aa", fontSize:"16px", fontWeight:"bold", cursor: 'pointer' }}></i>
                                    </label>
                                    <InputText id="nif" value={this.state.nif} disabled={true/*this.state.readOnlyMode || !this.state.canChangeNifInformation*/} type="text" onChange={(evt) => this.updateFormComponent("nif", evt.target.value)} />
                                    { this.state.validNif ? null : <p><small className="p-error">{this.props.t("general.mandatory-field")}</small></p>  }
                                    { this.state.validNifFormat ? null : <p><small className="p-error">{this.props.t("profile.areas.personal.invalid-nif")}</small></p>  }
                                </div>
                                {
                                    this.props.organicUnits !== null && this.props.organicUnits.length > 0 ?
                                        <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                                            <label htmlFor="niss">{this.props.t("profile.areas.personal.niss")}</label>
                                            <InputText id="niss" value={this.state.niss} disabled={this.state.readOnlyMode} type="text" onChange={(evt) => this.updateFormComponent("niss", evt.target.value)} />
                                            { this.state.validNiss ? null : <p><small className="p-error">{this.props.t("profile.areas.personal.invalid-niss")}</small></p>  }
                                        </div>
                                        : null
                                }
                                {
                                    this.props.organicUnits !== null && this.props.organicUnits.length > 0 ?
                                        <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                            <label htmlFor="iban">{this.props.t("profile.areas.personal.iban")}</label>
                                            <InputText id="iban" value={this.state.iban} disabled={this.state.readOnlyMode} type="text" onChange={(evt) => this.updateFormComponent("iban", evt.target.value)} />
                                            { this.state.validIban ? null : <p><small className="p-error">{this.props.t("profile.areas.personal.invalid-iban")}</small></p>  }
                                        </div>
                                        : null
                                }
                                <div className='col-12'><hr/></div>
                                <div className='col-12 t-align-left'>
                                    {
                                        this.state.identificationDoc !== null ?                                    
                                            <span onClick={() => this.downloadDocument(this.state.identificationDoc.nodeRef)}>
                                                <Chip title={this.props.t("general.download")} style={{color: "#FFFFFF", background:"#0073aa", cursor: 'pointer'}} label={this.props.t("profile.areas.personal.documents.document-id")} icon="pi pi-download" className="mr-2 mb-2" />
                                            </span>
                                            : null
                                    }
                                    {
                                        this.state.criminalDoc !== null ?
                                            <span className={isMobileOnly ? '' : 'mgl-10'} onClick={() => this.downloadDocument(this.state.criminalDoc.nodeRef)}>
                                                <Chip title={this.props.t("general.download")} style={{color: "#FFFFFF", background:"#0073aa", cursor: 'pointer'}} label={this.props.t("profile.areas.personal.documents.criminal-record")} icon="pi pi-download" className="mr-2 mb-2" />
                                            </span>
                                            : null
                                    }
                                    {
                                        this.state.photoDoc !== null ?
                                            <span className={isMobileOnly ? '' : 'mgl-10'} onClick={() => this.downloadDocument(this.state.photoDoc.nodeRef)}>
                                                <Chip title={this.props.t("general.download")} style={{color: "#FFFFFF", background:"#0073aa", cursor: 'pointer'}} label={this.props.t("profile.areas.personal.documents.photo")} icon="pi pi-download" className="mr-2 mb-2" />
                                            </span>
                                            : null
                                    }
                                    {
                                        this.state.signatureDoc !== null ?
                                            <span className={isMobileOnly ? '' : 'mgl-10'} onClick={() => this.downloadDocument(this.state.signatureDoc.nodeRef)}>
                                                <Chip title={this.props.t("general.download")} style={{color: "#FFFFFF", background:"#0073aa", cursor: 'pointer'}} label={this.props.t("profile.areas.personal.documents.signature")} icon="pi pi-download" className="mr-2 mb-2" />
                                            </span>
                                            : null
                                    }
                                    {
                                        this.state.compNifDoc !== null ?
                                            <span className={isMobileOnly ? '' : 'mgl-10'} onClick={() => this.downloadDocument(this.state.compNifDoc.nodeRef)}>
                                                <Chip title={this.props.t("general.download")} style={{color: "#FFFFFF", background:"#0073aa", cursor: 'pointer'}} label={this.props.t("profile.areas.personal.documents.comp-nif")} icon="pi pi-download" className="mr-2 mb-2" />
                                            </span>
                                            : null
                                    }
                                    {
                                        this.props.associate.personalData.portugueseCitizen === false && this.state.residenceDoc !== null ?
                                            <span className={isMobileOnly ? '' : 'mgl-10'} onClick={() => this.downloadDocument(this.state.residenceDoc.nodeRef)}>
                                                <Chip title={this.props.t("general.download")} style={{color: "#FFFFFF", background:"#0073aa", cursor: 'pointer'}} label={this.props.t("profile.areas.personal.documents.residence")} icon="pi pi-download" className="mr-2 mb-2" />
                                            </span>
                                            : null
                                    }
                                </div>
                                {
                                    this.state.readOnlyMode === false ?
                                        <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                            <FileUpload mode="basic" 
                                                        accept="application/pdf" 
                                                        chooseLabel={this.props.t("profile.areas.personal.upload-criminal-doc")}
                                                        maxFileSize={1000000} 
                                                        uploadHandler={(evt) => this.uploadDocumentHandler(evt.files, 'criminal_record')} customUpload={true} auto={true}
                                                        onValidationFail={(evt) => this.setState({validUploadFile: false})} />
                                            {
                                                this.state.criminalDocAttachment !== null ? 
                                                    <span>{this.state.criminalDocAttachmentName}</span> : null
                                            }
                                        </div>
                                        : null
                                }
                                {
                                    this.state.readOnlyMode === false ?
                                        <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                            <FileUpload mode="basic" 
                                                        accept="image/*" 
                                                        chooseLabel={this.props.t("profile.areas.personal.upload-photo")}
                                                        maxFileSize={1000000} 
                                                        uploadHandler={(evt) => this.uploadDocumentHandler(evt.files, 'photo')} customUpload={true} auto={true}
                                                        onValidationFail={(evt) => this.setState({validUploadFile: false})} />
                                            {
                                                this.state.photoAttachment !== null ? 
                                                    <span>{this.state.photoAttachmentName}</span> : null
                                            }
                                        </div>
                                        : null
                                }
                                { this.state.validUploadFile ? null : <div className='col-12 t-align-left'><small className="p-error">{this.props.t("profile.areas.personal.invalid-file")}</small></div>  }
                            </div>
                        </div>
                    </div>
                    <Toast position='bottom-left' ref={this._toast} />
                </div>
                : null
            );
    }
}

const mapStateToProps = (state) => {
    return {
        associate: state.profile.associate,
        organicUnits: state.authentication.organicUnits,
        registrationDocs: state.profile.registrationDocs,
        registrationRef: state.authentication.registrationRef,
        registrationApproved: state.authentication.registrationApproved,
        language: state.profile.language
    } 
};
  
const mapDispatchToProps = (dispatch) => {
    return {
        setEditMode: (editMode) => { dispatch(setEditMode(editMode)) },
        getAssociateData: (registrationRef) => { dispatch(getAssociateData(registrationRef)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(PersonalDataComponent));